import { Pricing } from '../contracts';

const getDecimalPlaces = (multiplier?: number) => {
  switch (multiplier) {
    case 1:
      return 0;
    case 100:
      return 2;
    case 1000:
      return 3;
    default:
      return 2;
  }
};

export function getFormattedNumber(number?: number, pricing?: Pricing): string {
  let formattedNumber =
    pricing?.isCents && pricing?.multiplier
      ? `${(number as number) / pricing.multiplier}`
      : `${number}`;
  const decimalPlaces = getDecimalPlaces(pricing?.multiplier);

  const parts = formattedNumber.split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, pricing?.milSeparator as string);

  if (!parts[1]) {
    if (decimalPlaces === 0) {
      parts.length = 1;
    } else {
      parts[1] = '0'.repeat(decimalPlaces);
    }
  } else if (parts[1].length < decimalPlaces) {
    parts[1] = parts[1].padEnd(decimalPlaces, '0');
  } else {
    parts[1] = parts[1].substring(0, decimalPlaces);
  }

  formattedNumber = parts.join(pricing?.fractionalSeparator);

  return formattedNumber;
}
